import Menuline from '../components/icon/menu-line.png';
import Plussign from '../components/icon/download.png';
import Question from '../components/icon/question.png';
import History from '../components/icon/history.png';
import Setting from '../components/icon/setting.png';
import msgIcon from '../components/icon/msg-icon.png';
import manImg from '../components/img/man.jpeg';
import geminilogo from '../components/icon/gemini logo.png';
import navi from '../components/icon/navigation.png';
import ideaIcon from '../components/icon/idea.png';
import codeIcon from '../components/icon/code.png';

export const assets={
    Menuline,
    Plussign,
    Question,
    History,
    Setting,
    msgIcon,
    manImg,
    geminilogo,
    navi,
    ideaIcon,
    codeIcon

}